import { PricingMode, PricingModeKey } from '@mews/enums';
import { PricingModeConfiguration } from './types';

const pricingModeConfiguration: PricingModeConfiguration = {
    [PricingMode.Net]: PricingModeKey.NetValue,
    [PricingMode.Gross]: PricingModeKey.GrossValue,
    [PricingMode.Simple]: PricingModeKey.Value,
};

export default pricingModeConfiguration;
